<template>
  <div v-if="shiurim" class="text-center text-sm-left shiurim-component-card">
    <div class="aspect-ratio-fixed">
      <div class="shiurim-card-image">
        <div class="position-relative w-100 h-100 align-items-center justify-content-center text-center">
          <b-img-lazy class="shiurim-image w-100" :src="background" :alt="shiurim.name" fluid />
          <action-buttons :magid-shiur="shiurim.speaker" :shiurim="shiurim" type="torah"></action-buttons>
          <span class="force-oneline length-label length-label-right px-2">
            <div>
              <span v-if="!isRTL" :class="'fa ' + (isVideo ? 'fa-video-camera video-logo' : 'fa-volume-up audio-logo')"></span> {{ shiurim.length }}
              <span v-if="isRTL" :class="'fa ' + (isVideo ? 'fa-video-camera video-logo' : 'fa-volume-up audio-logo')"></span>
            </div>
          </span>
          <span class="force-oneline length-label length-label-left px-2">{{ shiurim.recorded }}</span>
        </div>
      </div>
    </div>
    <div class="media-progress-bar-container">
      <div :style="{ width: progress + '%' }"></div>
    </div>
    <div class="d-flex flex-column justify-content-center h-100 p-4 w-100">
      <div class>
        <router-link
          :class="isVideo ? 'shiurim-speaker-name-heading-video' : 'shiurim-speaker-name-heading-audio'"
          :to="{
            name: 'magideiShiurTorah',
            params: { slug: shiurim.speaker.url_key },
          }"
          >{{ shiurim.speaker.name }}</router-link
        >
      </div>
      <router-link :to="'/watch/' + shiurim.id">
        <div class="shiurim-name-limit my-2">
          <strong v-if="shiurTitle != shiurim.name" v-b-tooltip.hover :title="shiurim.name" class="shiurim-name-heading" :id="'shiurim-name-' + shiurim.id"
            >{{ shiurTitle }}...</strong
          >
          <strong v-else class="shiurim-name-heading">{{ shiurTitle }}</strong>
        </div>
      </router-link>
      <span class="shiurim-topic">Shiur# {{ shiurim.id + offset }}</span>
      <span>
        <topic-link class="shiurim-topic mb-2 mr-5" :topic="shiurim.topic"></topic-link>
      </span>
      <span
        v-b-tooltip.hover
        :title="isShiurimSaved ? $_t('KW:removeSavedShiurim') : $_t('KW:saveShiurim')"
        role="button"
        class="bookmark-icon"
        @click="saveShiurEvent"
      >
        <i class="text-primary fa fa-md" :class="isShiurimSaved ? 'fa-bookmark' : 'fa-bookmark-o'"></i>
      </span>
    </div>
  </div>
</template>

<script>
import TopicLinkComponent from '../magideiShiur/topicLink.vue';
import ActionButtonsComponent from './ActionButtons.vue';
import smartEllipsis from 'smart-ellipsis';
import { shiur_length_to_seconds } from '../../../../backend/js/libraries/Helpers';

export default {
  props: ['shiurim'],
  computed: {
    progress: function () {
      let history = this.shiurim.history;
      if (!history) return 0;
      return Math.floor((history.duration_played * 100) / shiur_length_to_seconds(this.shiurim.length));
    },
    background: function () {
      if (this.shiurim.url_video_thumbnail_resized) {
        return this.shiurim.url_video_thumbnail_resized;
      } else if (this.shiurim.speaker && this.shiurim.speaker.audio_thumbnail) {
        return this.shiurim.speaker.audio_thumbnail.thumbnail;
      }
      return '/static/img/audio-thumbnail.jpg';
    },
    isShiurimSaved: function () {
      if (this.$store.getters['auth/isLoggedIn']) {
        return this.$store.state.profile.savedShiurim.some(save => {
          return save.id === this.shiurim.id;
        });
      }
      return false;
    },
    isVideo: function () {
      var url = this.shiurim.url_video_preview || this.shiurim.url_video_download;
      return url && url != '';
    },
    shiurTitle: function () {
      let charLimit = 60;
      let windowWidth = window.innerWidth;
      if (windowWidth >= 768) {
        charLimit = 55;
      } else if (windowWidth >= 576) {
        charLimit = 45;
      } else {
        charLimit = 9999;
      }

      let shiurimName = this.shiurim.name.slice(0, charLimit);
      let lastChar = shiurimName.slice(-1);

      let numberOfLines = parseFloat(shiurimName.length / 12);

      while (lastChar.includes([':', '-']) && numberOfLines % 1 === 0) {
        charLimit -= 1;
        lastChar = shiurimName.slice(-1);
        numberOfLines = parseFloat(shiurimName.length / 12);
      }

      shiurimName = smartEllipsis(shiurimName.trim(), charLimit);

      return this.shiurim ? shiurimName : null;
    },
  },
    data: function() {
        return {
            offset: parseInt(process.env.MIX_CALL_SYSTEM_OFFSET_SHIURIM) || 0
        };
    },
  components: {
    ActionButtons: ActionButtonsComponent,
    TopicLink: TopicLinkComponent,
  },
  methods: {
    saveShiurEvent() {
      if (!this.$store.getters['auth/isLoggedIn']) {
        this.$store.dispatch('auth/showModal');
        return;
      }
      if (this.isShiurimSaved) {
        this.deleteShiurimForUser();
      } else {
        this.saveShiurimForUser();
      }
    },
    saveShiurimForUser() {
      this.$http.post('/api/user/save-shiur/' + this.shiurim.id).then(response => {
        let savedShiurim = this.$store.state.profile.savedShiurim;
        savedShiurim.push(response.data);
        this.$store.dispatch('profile/loadSavedShiurim', savedShiurim);
      });
    },
    deleteShiurimForUser() {
      this.$http.post('/api/user/remove-shiur/' + this.shiurim.id).then(response => {
        let savedShiurim = this.$store.state.profile.savedShiurim;
        savedShiurim = savedShiurim.filter(save => save.id !== this.shiurim.id);
        this.$store.dispatch('profile/loadSavedShiurim', savedShiurim);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.media-progress-bar-container {
  width: 100%;
  height: 2px;
  div {
    background: #d37f00;
    height: 2px;
  }
}
.force-oneline {
  white-space: nowrap;
}
.aspect-ratio-fixed {
  padding-top: 56.25%;
  position: relative;
  .shiurim-card-image {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: white;
    img {
      border-radius: 5px;
      max-height: 100%;
      border-radius: 5px;
    }

    .length-label {
      position: absolute;
      bottom: 0;
      background: rgba(0, 0, 0, 0.87);
      color: white;
      padding: 0 3px;
    }

    .length-label-right {
      right: 0;
    }

    .length-label-left {
      left: 0;
    }

    @media only screen and (max-width: 768px) {
      // height: 350px;
    }
    @media only screen and (max-width: 576px) {
      // height: 250px;
    }

    .action-btn-container {
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s;
      position: absolute;
      top: calc(50% - 20px);
      width: 100%;
      @media only screen and (max-width: 992px) {
        opacity: 0.9;
      }
    }
  }
}
.shiurim-component-card:hover {
  .action-btn-container {
    opacity: 0.9;
  }
}
</style>
